<template>
    <v-tooltip
        v-if="item.is_important"
        top
    >
        <template v-slot:activator="{ on }">
            <v-btn
                :color="item.is_important ? 'orange lighten-1' : 'grey'"
                class="mx-1"
                icon
                small
                v-on="on"
            >
                <v-icon>mdi-flag</v-icon>
            </v-btn>
        </template>
        {{ $t("important") }}
    </v-tooltip>
</template>

<script>
import { $t } from "@/i18n";

export default {
    name: "RichDataTableImportant",
    props: {
        item: {
            type: Object,
            default: null
        }
    }
};
</script>
